import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 7;

  /* @media ${({ theme }) => theme.devices.tablet} {
    padding: 0px !important;
  } */
`;
